import { useEffect } from 'react'

import { Loader } from '../../components/Loader'
import { getDisplayName } from '../getDisplayName'

import { useSignOut } from '@hooks/auth/sign-out.hook'
import { useMe } from '@hooks/user/me.hook'

interface Props {
  children?: React.ReactNode
}

export const UserGuard = (props: Props): JSX.Element => {
  const { children } = props

  const { signOut } = useSignOut()
  const { data, error } = useMe()

  const isMeAvailable = !!data?.me

  useEffect(() => {
    if (error) {
      signOut()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [error])

  return <>{isMeAvailable ? children : <Loader />}</>
}

// eslint-disable-next-line react-refresh/only-export-components
export const withUserGuard = <P extends object>(WrappedComponent: React.ComponentType<P>) => {
  const WithUserGuard = (props: P) => {
    return (
      <UserGuard>
        <WrappedComponent {...props} />
      </UserGuard>
    )
  }

  WithUserGuard.displayName = `WithUserGuard(${getDisplayName(WrappedComponent)})`

  return WithUserGuard
}
